import initialState from './initialstate';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function OfflinePrepReducer(
	state = initialState.offlinePrep,
	action
) {
	switch (action.type) {
		case 'SET_OFFLINE_PREP':
			/* Notice that this is simply returning the action payload, <%=names.camel%>.
			 * This is because the combineReducers() call wraps this reducer
			 * and passes it only the portion of the store state that it
			 * is concerned with. */
			console.log(`[${action.type}]: OfflinePrep reducer -`, action);
			// if (_.isBoolean(action.isOnline)) {
			// 	return action.isOnline;
			// }
			return action.isCompleted;
		default:
			return state;
	}
}
